import { Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { Appointment } from '../../../landing/models';
import * as moment from 'moment';
import { Globals } from '../../../globals';
import { HomeAccordionService } from '../controls/home-accordion/home-accordion.service';
import { fromEvent, Subscription } from 'rxjs';
import { MessagingService } from '../../../services/messaging.service';
import { StaticDataService } from '../../../services/static-data.service';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { MessagingConstants } from '../../../models/MessagingConstants';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { DialogService } from '../../../services/dialog.service';
import { PatientFlagDataModel } from '../../../models/patient/patient-flag-data.model';
import { AppointmentFlagDataModel } from '../../../models/appointments/appointment-flag-data.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { LocalStorageService } from '../../../services/local-storage.service';
import { SchedulingService } from '../../../modules/scheduling/scheduling.service';


@Component({
    selector: 'app-home-schedule-view',
    templateUrl: './home-schedule-view.component.html',
    styleUrls: ['./home-schedule-view.component.css']
})
export class HomeScheduleViewComponent implements OnInit, OnDestroy {
    @ViewChild('ctxMenu') contextMenu: TemplateRef<any>;
    @Output() requestClose = new EventEmitter();
    @Output() requestCheckOut = new EventEmitter();
    @Output() accordionClose = new EventEmitter<void>();


    doctorPredicate: (data: DoctorDataModel) => string;

    currAndFutureAppointments: Appointment[] = [];
    filteredAppointments: Appointment[] = [];
    selectedAppointmentId: string;
    scheduleDate: moment.Moment;
    today: moment.Moment = moment();
    subscriptions: Subscription[] = [];
    appointmentFlagEnums: EnumValidValueItemModel[];
    patientFlagEnums: EnumValidValueItemModel[];
    isCheckedIn: boolean = false;
    isCheckedOut: boolean = false;
    selectedDoctor: DoctorDataModel;

    private overlayRef: OverlayRef | null;
    private sub: Subscription;
    isContextOpen = false;

    constructor(private router: Router,
        private globals: Globals,
        private homeAccordionService: HomeAccordionService,
        private messagingService: MessagingService,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef,
        private dialogService: DialogService,
        public staticDataService: StaticDataService,
        private localStorageService: LocalStorageService,
        private schedulingService: SchedulingService
        // private uiService: UiService
    ) { }

    ngOnInit(): void {
        this.doctorPredicate = (data: DoctorDataModel) => 'Dr. ' + data.dataContact.LastName;
        const dateSub = this.homeAccordionService.changeDateEvent.subscribe({
            next: (appointments) => {
                this.currAndFutureAppointments = appointments;
                this.filteredAppointments = appointments;
                if (this.localStorageService.loggedInDoctorId) {
                    const ivl = setInterval(() => {
                        if (this.staticDataService.currentLocationDoctors && this.staticDataService.currentLocationDoctors.length > 0) {
                            clearInterval(ivl);
                            this.selectedDoctor = this.staticDataService.currentLocationDoctors.find(p => p.DoctorId.toLowerCase() === this.localStorageService.loggedInDoctorId.toLowerCase());
                            this.filteredAppointments = this.currAndFutureAppointments.filter(p => p.DoctorId.toLowerCase() === this.selectedDoctor.DoctorId.toLowerCase());
                            this.homeAccordionService.numScheduleItems = this.filteredAppointments.length;
                        }
                    }, 100);
                }

                this.homeAccordionService.numScheduleItems = this.filteredAppointments.length;
                this.scheduleDate = this.homeAccordionService.scheduleDate;
            }
        });
        this.subscriptions.push(dateSub);

        if (this.homeAccordionService.currAndFutureAppointments) {
            this.currAndFutureAppointments = this.homeAccordionService.currAndFutureAppointments;

            if (this.localStorageService.loggedInDoctorId) {
                const ivl = setInterval(() => {
                    if (this.staticDataService.currentLocationDoctors && this.staticDataService.currentLocationDoctors.length > 0) {
                        clearInterval(ivl);
                        this.selectedDoctor = this.staticDataService.currentLocationDoctors.find(p => p.DoctorId.toLowerCase() === this.localStorageService.loggedInDoctorId.toLowerCase());
                        this.filteredAppointments = this.currAndFutureAppointments.filter(p => p.DoctorId.toLowerCase() === this.selectedDoctor.DoctorId.toLowerCase());
                        this.homeAccordionService.numScheduleItems = this.filteredAppointments.length;
                    }
                }, 100);
            }
        }

        if (this.staticDataService.isReady) {
            this.setupEnums();
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupEnums();
                }
            });
        }
    }

    setupEnums() {
        this.appointmentFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumAppoitmentFlag');
        this.patientFlagEnums = this.staticDataService.getValidValueItemsByValidValueName('enumPatientFlag');
    }

    ngOnDestroy(): void {
        for (const sub of this.subscriptions) {
            if (sub)
            sub.unsubscribe();
        }
    }

    changePatient(appointment: Appointment) {
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: appointment.PatientId,
            PatientName: appointment.PatientName,
            clearCurrentQuery: false
        });

        this.requestClose.emit();
    }

    onDoctorSelect(doctor: DoctorDataModel) {
        // console.log('Doctor selected: ' + doctor.dataContact.FirstName);
    }

    onScheduleIconClick() {
        const calendarUrl = this.router.serializeUrl(
            this.router.createUrlTree(['/scheduler'])
          );
          let windowOptions = [
            'toolbar=no',
            'location=no',
            'menubar=no',
            'height=' + screen.height,
            'width=' + screen.width,
            'fullscreen=yes' // only works in IE, but here for completeness
          ].join(',');
          let storageName = 'tdoProCalendarWindow';
          let itemToStore = {};
          let postClosureEvents = [];
          let tdoProCalendarWindowId = this.messagingService.openPopUpWindow(calendarUrl, windowOptions, storageName, itemToStore, postClosureEvents, true, 'tdoProCalendarWindow');
    }

    getStartTime(appointment: Appointment) {
        const startTime = new Date(appointment.StartDateTime);
        let hours = startTime.getHours();
        let demarcation = 'AM';
        if (hours > 12) {
            hours -= 12;
            demarcation = 'PM';
        }

        const minutes = startTime.getMinutes();
        let minutesString = minutes.toString();
        if (minutes < 10) {
            minutesString = '0' + minutes.toString();
        }

        return hours + ':' + minutesString + ' ' + demarcation;
    }

    getDuration(appointment: Appointment) {
        const endTimeMs = new Date(appointment.EndDateTime).getTime();
        const startTimeMs = new Date(appointment.StartDateTime).getTime();
        const diffMs = endTimeMs - startTimeMs;

        const minutes = diffMs / 1000 / 60;
        let hours = 0;
        let minutesString = minutes.toString();
        if (minutes >= 60) {
            hours = Math.floor(minutes / 60);
            minutesString = (minutes % 60).toString();
        }

        if (hours >= 1) {
            if (hours === 1) {
                return hours.toString() + ' Hour ' + minutesString + ' Min';
            } else {
                return hours.toString() + ' Hours ' + minutesString + ' Min';
            }
        } else {
            return minutesString + ' Min';
        }
    }

    getOperatoryImage(operatoryId: string) {
        if (!this.staticDataService.currentLocationOperatories) {
            return;
        }

        const op = this.staticDataService.currentLocationOperatories.find(p => p.OperatoryId === operatoryId);
        if (op) {
            return op.avatar;
        } else {
            return null;
        }
    }

    getOperatoryName(operatoryId: string) {
        if (!this.staticDataService.currentLocationOperatories) {
            return;
        }

        const op = this.staticDataService.currentLocationOperatories.find(p => p.OperatoryId === operatoryId);
        if (op) {
            return op.OperatoryName;
        } else {
            return null;
        }
    }

    onPatientContextMenu(event: MouseEvent, appt: Appointment) {
        this.openContext(event, this.contextMenu, appt);
    }

    // Context menu
    // Context boilerplate
    openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
        this.isContextOpen = true;
        this.closeContext();
        x = x + 50;
        y = y - 20;
        const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
            {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }
        ]);

        this.overlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.close()
        });

        this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));

        this.sub = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter(event => {
                    if (closeOnItemClick) {
                        this.closeContext();
                    } else {
                        const clickTarget = event.target as HTMLElement;
                        return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
                    }
                }), take(1)).subscribe(() => this.closeContext());
    }

    closeContext(): void {
        this.sub !== undefined && this.sub.unsubscribe();
        if (this.overlayRef) {
            this.isContextOpen = false;
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }

    onCheckInPatient(appointment: Appointment) {
        this.requestClose.emit();
        this.dialogService.openPatientCheckInDialog(appointment).subscribe((res) => {
            if (res) {
                this.currAndFutureAppointments.find(x => x.AppointmentId === appointment.AppointmentId).isCheckedIn = true;
            }
        });
    }

    getPatientFlagImage(flag: PatientFlagDataModel) {
        if (this.patientFlagEnums) {
            const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
            if (enu) {
                return enu.IconIDSVG;
            }
        }
    }

    getPatientFlagTooltip(flag: PatientFlagDataModel) {

        if (this.patientFlagEnums) {
            const enu = this.patientFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumPatientFlagID.toLowerCase());
            if (enu) {
                return enu.ItemDisplayValue;
            }
        }
        return '';
    }

    getAppointmentFlagImage(flag: AppointmentFlagDataModel) {
        if (this.appointmentFlagEnums) {

            const enu = this.appointmentFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumAppoitmentFlagID.toLowerCase());
            if (enu) {
                return enu.IconIDSVG;
            }
        }
    }

    getAppointmentFlagTooltip(flag: AppointmentFlagDataModel) {
        if (this.appointmentFlagEnums) {
            const enu = this.appointmentFlagEnums.find(p => p.ValidValueItemId.toLowerCase() === flag.enumAppoitmentFlagID.toLowerCase());
            if (enu) {
                return enu.ItemDisplayValue;
            }
        }

        return '';
    }
    onCheckOutPatient(event: Event, appointment: Appointment) {
        event.stopPropagation();
        this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
            PatientID: appointment.PatientId,
            PatientName: appointment.PatientName,
            Process: MessagingConstants.CHECKOUT_PATIENT_START,
            PatientCaseId: appointment.PatientCaseId,
            clearCurrentQuery: false
        });
        this.accordionClose.emit();
    }

    getBackgroundColor(appt: Appointment) {
        if (appt.isDeceased) {
            return '#a4b589';
        } else if (appt.isDoNotEverTreatAgain) {
            return '#b58989';
        }
    }

    onDoctorSelected(event: TdoDropdownChange) {
        if (event.value) {
            this.filteredAppointments = this.currAndFutureAppointments.filter(p => p.DoctorId.toLowerCase() === event.value.DoctorId.toLowerCase());
            this.homeAccordionService.numScheduleItems = this.filteredAppointments.length;
        }
    }

    onClearDoctor() {
        this.selectedDoctor = null;
        this.filteredAppointments = this.currAndFutureAppointments;
        this.homeAccordionService.numScheduleItems = this.filteredAppointments.length;
    }
}
